import script from "./ReferenceDialogs.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceDialogs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__